import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const FormFieldCheckInputOption = (props)=> {

  let {
    id,
    value,
    placeholder,
    controlType,
    readOnly,
    fieldName,
    checked,
  } = props;

  let [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(props.inputValue || '');
  },[props.inputValue]);

  const onChange = () => {
    if (props.onChange) {
      props.onChange(fieldName, value, inputValue);
    }
  };

  const onBlur = () => {
    if (props.onBlur) {
      props.onBlur(fieldName, value, inputValue);
    }
  };

  const updateFieldInputValue = (e) => {
    let element = e.target;
    let _inputValue = element.value?element.value:'';

    if (props.onChange) {
      props.onChange(fieldName, value, _inputValue);
    }
  };

  return (
    <Form.Check id={id}
                inline name={fieldName}
                value={value}
                disabled={readOnly}
                type={controlType}
                feedback={undefined}
    >
      <Form.Check.Input name={fieldName} type={controlType} isValid value={value}
                        checked={checked}
                        onChange={onChange}
                        onBlur={onBlur} />
      <Form.Check.Label>
        <Form.Control placeholder={placeholder}
                      value={inputValue}
                      onChange={updateFieldInputValue}/>
      </Form.Check.Label>
    </Form.Check>
  )

};

FormFieldCheckInputOption.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  inputValue: PropTypes.string,
  controlType: PropTypes.string,
  readOnly: PropTypes.bool,
  checked: PropTypes.bool,
  fieldName: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default FormFieldCheckInputOption;


